[
  "AND",
  "ARE",
  "AFG",
  "ATG",
  "AIA",
  "ALB",
  "ARM",
  "AGO",
  "ATA",
  "ARG",
  "ASM",
  "AUT",
  "AUS",
  "ABW",
  "ALA",
  "AZE",
  "BIH",
  "BRB",
  "BGD",
  "BEL",
  "BFA",
  "BGR",
  "BHR",
  "BDI",
  "BEN",
  "BLM",
  "BMU",
  "BRN",
  "BOL",
  "BES",
  "BRA",
  "BHS",
  "BTN",
  "BVT",
  "BWA",
  "BLR",
  "BLZ",
  "CAN",
  "CCK",
  "COD",
  "CAF",
  "COG",
  "CHE",
  "CIV",
  "COK",
  "CHL",
  "CMR",
  "CHN",
  "COL",
  "CRI",
  "CUB",
  "CPV",
  "CUW",
  "CXR",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DNK",
  "DMA",
  "DOM",
  "DZA",
  "ECU",
  "EST",
  "EGY",
  "ESH",
  "ERI",
  "ESP",
  "ETH",
  "FIN",
  "FJI",
  "FLK",
  "FSM",
  "FRO",
  "FRA",
  "GAB",
  "GBR",
  "GRD",
  "GEO",
  "GUF",
  "GGY",
  "GHA",
  "GIB",
  "GRL",
  "GMB",
  "GIN",
  "GLP",
  "GNQ",
  "GRC",
  "SGS",
  "GTM",
  "GUM",
  "GNB",
  "GUY",
  "HKG",
  "HMD",
  "HND",
  "HRV",
  "HTI",
  "HUN",
  "IDN",
  "IRL",
  "ISR",
  "IMN",
  "IND",
  "IOT",
  "IRQ",
  "IRN",
  "ISL",
  "ITA",
  "JEY",
  "JAM",
  "JOR",
  "JPN",
  "KEN",
  "KGZ",
  "KHM",
  "KIR",
  "COM",
  "KNA",
  "PRK",
  "KOR",
  "KWT",
  "CYM",
  "KAZ",
  "LAO",
  "LBN",
  "LCA",
  "LIE",
  "LKA",
  "LBR",
  "LSO",
  "LTU",
  "LUX",
  "LVA",
  "LBY",
  "MAR",
  "MCO",
  "MDA",
  "MNE",
  "MAF",
  "MDG",
  "MHL",
  "MKD",
  "MLI",
  "MMR",
  "MNG",
  "MAC",
  "MNP",
  "MTQ",
  "MRT",
  "MSR",
  "MLT",
  "MUS",
  "MDV",
  "MWI",
  "MEX",
  "MYS",
  "MOZ",
  "NAM",
  "NCL",
  "NER",
  "NFK",
  "NGA",
  "NIC",
  "NLD",
  "NOR",
  "NPL",
  "NRU",
  "NIU",
  "NZL",
  "OMN",
  "PAN",
  "PER",
  "PYF",
  "PNG",
  "PHL",
  "PAK",
  "POL",
  "SPM",
  "PCN",
  "PRI",
  "PSE",
  "PRT",
  "PLW",
  "PRY",
  "QAT",
  "REU",
  "ROU",
  "SRB",
  "RUS",
  "RWA",
  "SAU",
  "SLB",
  "SYC",
  "SDN",
  "SWE",
  "SGP",
  "SHN",
  "SVN",
  "SJM",
  "SVK",
  "SLE",
  "SMR",
  "SEN",
  "SOM",
  "SUR",
  "SSD",
  "STP",
  "SLV",
  "SXM",
  "SYR",
  "SWZ",
  "TCA",
  "TCD",
  "ATF",
  "TGO",
  "THA",
  "TJK",
  "TKL",
  "TLS",
  "TKM",
  "TUN",
  "TON",
  "TUR",
  "TTO",
  "TUV",
  "TWN",
  "TZA",
  "UKR",
  "UGA",
  "UMI",
  "USA",
  "URY",
  "UZB",
  "VAT",
  "VCT",
  "VEN",
  "VGB",
  "VIR",
  "VNM",
  "VUT",
  "WLF",
  "WSM",
  "YEM",
  "MYT",
  "ZAF",
  "ZMB",
  "ZWE",
  "XKX"
]
